export default
{
  adblock: 'Hallo! Diese Website ist transparent und bietet Ihnen die Möglichkeit, die Dienste von Drittanbietern zu aktivieren.',
  adblock_call: 'Bitte deaktivieren Sie Ihren Adblocker, um die Anpassung zu starten.',
  reload: 'Die Seite neu laden',

  alertDisclaimerTitle: 'Ihre Privatsphäre hat für uns Priorität',
  alertDisclaimer: 'Mit der Fortsetzung Ihres Browsens stimmen Sie der Verwendung von Cookies durch uns und unsere Partner zu, um Inhalte und Angebote bereitzustellen, die auf Ihre Interessen zugeschnitten sind, sowie personalisierte Werbung und Traffic-Analysen.',
  alertDisclaimerText: '<p>Wenn Sie diese Website besuchen, können wir und unsere Partner unabhängig oder gemeinsam Cookies und ähnliche Technologien hinterlegen, um Informationen, einschließlich personenbezogener Daten, zu sammeln, wie z. B.: IP-Adresse, eindeutige Kennungen, Navigationsdaten, Geolokalisierungsdaten. </p><p>Diese Daten werden von uns und/oder unseren Partnern, einschließlich Werbepartnern, zu folgenden Zwecken verarbeitet: Analyse und Verbesserung des Nutzererlebnisses, Speicherung von und/oder Zugriff auf Informationen über ein Endgerät, Messung und Analyse des Publikums, Interaktion mit sozialen Netzwerken, Betrugsbekämpfung, Anzeige personalisierter Werbung und Inhalte, Messung der Leistung von Werbung und Inhalten.</p><p>Mit Ausnahme derjenigen, die für den Betrieb der Website sowie unter bestimmten Bedingungen für die Publikumsmessung erforderlich sind, können Cookies und ähnliche Technologien nur mit Ihrer Zustimmung hinterlegt werden. Sie können Ihre Zustimmung jederzeit frei erteilen, verweigern oder zurückziehen, indem Sie auf unser Cookie-Einstellungstool zugreifen. Wenn Sie der Verwendung dieser Technologien nicht zustimmen, gehen wir davon aus, dass Sie auch der Hinterlegung von Cookies widersprechen, die einige Partner mit einem berechtigten Interesse rechtfertigen.</p>',
  alertBigScroll: 'Indem Sie weiter blättern,',
  alertBigClick: 'Indem Sie Ihre Navigation fortsetzen,',
  alertBig: 'sie stimmen der nutzung von drittanbietern zu, die cookies setzen können.',

  alertBigPrivacy: 'Diese Website verwendet Cookies und gibt Ihnen die Kontrolle darüber, was Sie aktivieren möchten.',
  alertSmall: 'Servicemanagement',
  acceptAll: 'Okay, akzeptiere alles.',
  personalize: 'Mehr erfahren und einrichten',
  close: '&times;',
  closeTitle: 'Schließen Sie das Fenster',

  privacyUrl: 'Datenschutzerklärung',

  all: 'Präferenz für alle Dienstleistungen',

  info: 'Schutz Ihrer Privatsphäre',
  disclaimer: 'Durch die Autorisierung dieser Dienste von Drittanbietern erklären Sie sich mit dem Platzieren und Lesen von Cookies und dem Einsatz von Tracking-Technologien einverstanden, die für deren ordnungsgemäße Funktion erforderlich sind.',
  allow: 'Autorisieren',
  deny: 'Verbieten',
  noCookie: 'Dieser Service setzt keine Cookies ein.',
  useCookie: 'Dieser Service kann bis zu einer Höhe von',
  useCookieCurrent: 'Dieser Service hat gesetzt',
  useNoCookie: 'Dieser Service hat keine Cookies hinterlegt.',
  more: 'Um mehr darüber zu erfahren',
  source: 'Besuchen Sie die offizielle Website',
  credit: 'Cookie-Management durch Nematis',

  toggleInfoBox: 'Anzeigen/Verbergen von Cookie-Speicherinformationen',
  title: 'Verwalten Ihrer Cookie-Einstellungen',
  cookieDetail: 'Details zu Cookies',
  ourSite: 'auf unserer Website',
  newWindow: '(neues Fenster)',
  accept: 'Ich akzeptiere',
  allowAll: 'Alle Cookies zulassen',
  denyAll: 'Alle Cookies verbieten',

  fallback: 'ist deaktiviert.',

  disabled_content: '%service% ist deaktiviert. Ermöglichen Sie das Setzen von Cookies für den Zugriff auf den Inhalt.',
  disabled_video: '%service% ist deaktiviert. Erlauben Sie das Setzen von Cookies, um das Video abzuspielen.',

  technical: {
    title: 'Technische Cookies',
    details: ''
  },
  ads: {
    title: 'Werbeagenturen',
    details: 'Werbeagenturen generieren Einnahmen durch die Vermarktung der Werbefläche der Website.'
  },
  analytic: {
    title: 'Publikumsmessung',
    details: 'Die Dienstleistungen der Publikumsmessung ermöglichen es, Verkehrsstatistiken zu erstellen, die für die Verbesserung der Website nützlich sind.'
  },
  social: {
    title: 'Soziale Netzwerke',
    details: 'Soziale Netzwerke verbessern die Benutzerfreundlichkeit der Website und helfen, sie durch Austausch zu fördern.'
  },
  video: {
    title: 'Videos',
    details: 'Video-Sharing-Dienste bereichern die Website mit multimedialen Inhalten und erhöhen ihre Sichtbarkeit.'
  },
  comment: {
    title: 'Kommentare',
    details: 'Kommentar-Manager machen es einfach, Ihre Kommentare zu posten und Spam zu bekämpfen.'
  },
  support: {
    title: 'Unterstützung',
    details: 'Mit den Support-Dienstleistungen können Sie sich an das Standort-Team wenden und es verbessern.'
  },
  api: {
    title: 'APIs',
    details: 'APIs ermöglichen das Laden von Skripten: Geolokalisierung, Suchmaschinen, Übersetzungen,.....'
  },
  other: {
    title: 'Andere',
    details: 'Dienste zur Anzeige von Webinhalten.'
  }
}
